import React, { lazy, Suspense } from 'react';

const LazyUserEmailConfirmationPage = lazy(() => import('./UserEmailConfirmationPage'));

const UserEmailConfirmationPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyUserEmailConfirmationPage {...props} />
  </Suspense>
);

export default UserEmailConfirmationPage;
